import React, { useState, useRef, useEffect } from 'react';
import './Reserve.css';
import tableBackground from '../assets/optimized/table.webp';
function useInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setInView(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}
export default function Reserve() {
  const [ref, inView] = useInView();
  const [form, setForm] = useState({
    name: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    notes: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);
  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };
  const inputStyle = name => ({
    width: '100%',
    background: 'transparent',
    border: 'none',
    borderBottom: `1px solid ${focused === name ? 'rgba(230,210,173,0.7)' : 'rgba(230,210,173,0.2)'}`,
    padding: '12px 0',
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(18px, 1.2vw, 20px)',
    color: '#FFF6E8',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    WebkitAppearance: 'none'
  });
  const labelStyle = {
    display: 'block',
    fontFamily: "'Jost', sans-serif",
    fontSize: '18px',
    letterSpacing: '3px',
    color: 'rgba(230,210,173,0.6)',
    textTransform: 'uppercase',
    marginBottom: '8px'
  };
  return <section id="reserve" ref={ref} className="reserve__auto-1" style={{ '--reserve-table-bg': `url("${tableBackground}")` }}>
      <div className="reserve__auto-2" />

      <div className="reserve__auto-3 reserve__content-column">
        {/* Header */}
        <div style={{
        textAlign: 'center',
        marginBottom: 'clamp(28px, 4vw, 44px)',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
          <div className="reserve__auto-4">
            <div className="reserve__auto-5" />
            <span className="reserve__auto-6">Join Us</span>
            <div className="reserve__auto-7" />
          </div>
          <h2 className="reserve__auto-8">
            Reserve a Table
          </h2>
          <p className="reserve__auto-9">
            For groups of 8 or more, please call us directly
          </p>
        </div>

        {/* Form */}
        {!submitted ? <div className="reserve__form-card" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s ease 0.2s'
      }}>
            <form onSubmit={handleSubmit}>
              <div className="reserve__auto-10">
                <div>
                  <label style={labelStyle}>Your Name</label>
                  <input required type="text" placeholder="Full name" value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} onFocus={() => setFocused('name')} onBlur={() => setFocused(null)} style={{
                ...inputStyle('name'),
                '::placeholder': {
                  color: 'rgba(255,246,232,0.4)'
                }
              }} />
                </div>
                <div>
                  <label style={labelStyle}>Phone</label>
                  <input required type="tel" placeholder="+91 00000 00000" value={form.phone} onChange={e => setForm({
                ...form,
                phone: e.target.value
              })} onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)} style={inputStyle('phone')} />
                </div>
              </div>

              <div className="reserve__auto-11">
                <div>
                  <label style={labelStyle}>Date</label>
                  <input required type="date" value={form.date} onChange={e => setForm({
                ...form,
                date: e.target.value
              })} onFocus={() => setFocused('date')} onBlur={() => setFocused(null)} style={{
                ...inputStyle('date'),
                colorScheme: 'dark'
              }} />
                </div>
                <div>
                  <label style={labelStyle}>Time</label>
                  <select value={form.time} onChange={e => setForm({
                ...form,
                time: e.target.value
              })} onFocus={() => setFocused('time')} onBlur={() => setFocused(null)} style={{
                ...inputStyle('time'),
                cursor: 'pointer'
              }}>
                    <option value="" className="reserve__auto-12">Select time</option>
                    {['12:00 PM', '1:00 PM', '2:00 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM', '9:30 PM', '10:00 PM'].map(t => <option key={t} value={t} className="reserve__auto-13">{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Guests</label>
                  <select value={form.guests} onChange={e => setForm({
                ...form,
                guests: e.target.value
              })} onFocus={() => setFocused('guests')} onBlur={() => setFocused(null)} style={{
                ...inputStyle('guests'),
                cursor: 'pointer'
              }}>
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(n => <option key={n} value={n} className="reserve__auto-14">{n} {n === 1 ? 'Guest' : 'Guests'}</option>)}
                  </select>
                </div>
              </div>

              <div className="reserve__auto-15">
                <label style={labelStyle}>Special Requests</label>
                <textarea placeholder="Dietary requirements, celebrations, seating preferences..." value={form.notes} onChange={e => setForm({
              ...form,
              notes: e.target.value
            })} onFocus={() => setFocused('notes')} onBlur={() => setFocused(null)} rows={3} style={{
              ...inputStyle('notes'),
              resize: 'none',
              borderBottom: 'none',
              border: `1px solid ${focused === 'notes' ? 'rgba(230,210,173,0.4)' : 'rgba(230,210,173,0.12)'}`,
              padding: '14px',
              transition: 'border-color 0.3s ease'
            }} />
              </div>

              <div className="reserve__auto-16">
                <SubmitButton />
              </div>
            </form>
          </div> : <div className="reserve__auto-17">
            <div className="reserve__auto-18">OK</div>
            <h3 className="reserve__auto-19">
              Reservation Requested
            </h3>
            <p className="reserve__auto-20">
              Thank you, {form.name}. We'll confirm your table via WhatsApp shortly.<br />
              We look forward to welcoming you to Wild Elephant.
            </p>
          </div>}
      </div>
    </section>;
}
function SubmitButton() {
  const [hov, setHov] = useState(false);
  return <button type="submit" onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)} style={{
    fontFamily: "'Jost', sans-serif",
    fontSize: '19px',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    padding: '18px 64px',
    background: hov ? '#711d10' : 'linear-gradient(135deg, #E6D2AD, #F5E6C9)',
    color: hov ? '#E8DDC3' : '#050505',
    border: hov ? '1px solid #9A321D' : '1px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transform: hov ? 'translateY(-2px)' : 'translateY(0)',
    boxShadow: hov ? '0 12px 34px rgba(113, 29, 16, 0.36)' : 'none',
    fontWeight: 400
  }}>
      Confirm Reservation
    </button>;
}
